import { SELECTION_ALL } from "../common/constants";
import { APIClient } from "../helpers/api_helper";
import { CREATE_ADMIN_COMPANY, CREATE_ADMIN_COMPANY_DEVICE, CREATE_ADMIN_COMPANY_DEVICE_CONTRACT, CREATE_ADMIN_COMPANY_DEVICE_UPDATE, CREATE_ADMIN_COMPANY_SIM, GET_ADMIN_COMPANY, GET_ADMIN_COMPANY_DEVICE, GET_ADMIN_COMPANY_DEVICE_CONTRACT, GET_ADMIN_COMPANY_DEVICE_UPDATE, GET_ADMIN_COMPANY_DEVICE_UPDATE_PHOTO, GET_ADMIN_COMPANY_SIM, UPDATE_ADMIN_COMPANY, UPDATE_ADMIN_COMPANY_DEVICE, UPDATE_ADMIN_COMPANY_SIM } from "../helpers/url_helper";

const api = new APIClient();

export const getCompaniesByAdmin = async (isEnabled = false) => {
    let result = await api.get(GET_ADMIN_COMPANY +"?is_enabled=" + isEnabled);
    return result;
};

export const updateCompaniesByAdmin = async (data) => {
    try {
        let result = await api.put(UPDATE_ADMIN_COMPANY+ "/"+data.id, data);
        return result;
    }
    catch (error) {
        return false;
    }
};

export const createCompaniesByAdmin = async (data) => {
    try {
        let result = await api.create(CREATE_ADMIN_COMPANY, data);
        return result;
    }
    catch (error) {
        return false;
    }
};

export const getCompaniesSimByAdmin = async (isEffective = false, companyID = SELECTION_ALL) => {
    let result = await api.get(GET_ADMIN_COMPANY_SIM +"?is_effective=" + isEffective + "&admin_company_id=" + (companyID===null?SELECTION_ALL:companyID));
    return result;
};

export const createCompaniesSimByAdmin = async (data) => {
    try {
        let result = await api.create(CREATE_ADMIN_COMPANY_SIM, data);
        return result;
    }
    catch (error) {
        return false;
    }
};

export const updateCompaniesSimByAdmin = async (data) => {
    try {
        let result = await api.put(UPDATE_ADMIN_COMPANY_SIM+ "/"+data.id, data);
        return result;
    }
    catch (error) {
        return false;
    }
};

export const getCompaniesDeviceByAdmin = async (isEffective = false, companyID = SELECTION_ALL) => {
    let result = await api.get(GET_ADMIN_COMPANY_DEVICE +"?is_effective=" + isEffective + "&admin_company_id=" + (companyID===null?SELECTION_ALL:companyID));
    return result;
};

export const createCompaniesDeviceByAdmin = async (data) => {
    try {
        let result = await api.create(CREATE_ADMIN_COMPANY_DEVICE, data);
        return result;
    }
    catch (error) {
        return false;
    }
};

export const updateCompaniesDeviceByAdmin = async (data) => {
    try {
        let result = await api.put(UPDATE_ADMIN_COMPANY_DEVICE+ "/"+data.id, data);
        return result;
    }
    catch (error) {
        return false;
    }
};

export const getCompaniesDeviceRecordByAdmin = async (deviceID = SELECTION_ALL, companyID = SELECTION_ALL, limit = 20) => {
    if (deviceID === null) {
        deviceID = SELECTION_ALL;
    }
    if (companyID === null) {
        companyID = SELECTION_ALL;  
    }
    let result = await api.get(GET_ADMIN_COMPANY_DEVICE_UPDATE + "?device_id=" + (deviceID===undefined?SELECTION_ALL:deviceID) + "&company_id=" + (companyID===undefined?SELECTION_ALL:companyID) + "&limit=" + limit);
    return result;
};


export const createCompaniesDeviceUpdateByAdmin = async (data, config) => {
    try {
        let result = await api.create(CREATE_ADMIN_COMPANY_DEVICE_UPDATE, data, config);
        return result;
    }
    catch (error) {
        return false;
    }
};

export const getCompaniesDeviceRecordUpdatePhotoByAdmin = async (updateID = SELECTION_ALL) => {
    let result = await api.get(GET_ADMIN_COMPANY_DEVICE_UPDATE_PHOTO + "/" + updateID);
    return result;
};

export const getCompaniesDeviceContractByAdmin = async (deviceID = SELECTION_ALL, companyID = SELECTION_ALL, limit = 20, isActiveOnly = false, isLatest = false) => {
    if (deviceID === null) {
        deviceID = SELECTION_ALL;
    }
    if (companyID === null) {
        companyID = SELECTION_ALL;  
    }
    let result = await api.get(GET_ADMIN_COMPANY_DEVICE_CONTRACT + "?device_id=" + (deviceID===undefined?SELECTION_ALL:deviceID) + "&company_id=" + (companyID===undefined?SELECTION_ALL:companyID) + "&limit=" + limit + "&isActiveOnly=" + isActiveOnly + "&isLatest=" + isLatest);
    return result;
};

export const createCompaniesDeviceContractByAdmin = async (data) => {
    try {
        let result = await api.create(CREATE_ADMIN_COMPANY_DEVICE_CONTRACT, data);
        return result;
    }
    catch (error) {
        return false;
    }
};
